// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"92":"cdbd9270","2136":"40b74aca","7411":"55f94d51","8900":"55c8c605"}[chunkId] + ".css";
};